import { Button, Tab, Tabs, Box } from '@sixfold/common-ui';
import { Localized, useLocalization } from '@sixfold/localization-component';
import * as React from 'react';

import { SharedViewEmailSent } from './shared_view_email_sent';
import { SharedViewLoginTab } from './shared_view_login_tab';
import { Footer } from '../../footer/footer';
import { MapPageFrame } from '../../map_page_frame';

import styles from './styles.module.css';

type Props = {
  onTransporeonLoginClick: () => void;
};

export const LandingPageContent: React.FC<Props> = ({ onTransporeonLoginClick }) => {
  const [sentToEmail, setSentToEmail] = React.useState<string | undefined>(undefined);
  const footer = React.useMemo(() => <Footer />, []);
  const companyLoginTabTitle = useLocalization('landing.page.tab.companyLogin.title', 'Log in to a company');
  const sharedViewLoginTabTitle = useLocalization('landing.page.tab.sharedViewLogin.title', 'Log in to a shared view');

  if (sentToEmail !== undefined) {
    return <SharedViewEmailSent email={sentToEmail} />;
  }

  return (
    <MapPageFrame showHeader={true} footer={footer} showLoginLink>
      <Tabs defaultActiveIndex={0} alignment="center" className={{ container: styles.tabs, tabItems: styles.tabItems }}>
        <Tab title={companyLoginTabTitle} id="company" padding={0}>
          <Box paddingBlockStart="xlarge">
            <Button fullWidth kind="primary" onClick={onTransporeonLoginClick}>
              <Localized id="login.button.transporeon">
                Log in with <span>Transporeon</span>
              </Localized>
            </Button>
          </Box>
        </Tab>
        <Tab title={sharedViewLoginTabTitle} id="shared-view" padding={0}>
          <Box paddingBlockStart="xlarge">
            <SharedViewLoginTab onEmailSent={setSentToEmail} />
          </Box>
        </Tab>
      </Tabs>
    </MapPageFrame>
  );
};
